var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRtmpHandleUpdatingUrlSettings01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        font-size: 12.94px;\n        font-family: MyriadPro-Regular, Myriad Pro;\n      }\n\n      .cls-3 {\n        letter-spacing: 0em;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "RTMP handle Updating URL Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.95,
    y: 13,
    width: 50.67,
    height: 35.58,
    rx: 1.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.68,
    y1: 19.09,
    x2: 55.34,
    y2: 19.09
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 8.45,
    cy: 15.7,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.68,
    cy: 15.7,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.92,
    cy: 15.7,
    r: 0.81
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(10.4 37.46)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3"
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.13,
    y: 0
  }, "ttps:"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.85,
    y: 0
  }, "//")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtmpHandleUpdatingUrlSettings01);
export default __webpack_public_path__ + "static/media/RTMP_handle_Updating_URL_Settings_01.03308b3c4e828703c97c25681c3eff4e.svg";
export { ForwardRef as ReactComponent };